import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface UpdatePrioritizationRequest {
  prioritization: boolean;
  reason: string | null;
}

export interface ITraceabilityCommandPort {
  updatePrioritization(
    lgCode: string,
    request: UpdatePrioritizationRequest
  ): Observable<void>;
}

export const TRACEABILITY_COMMAND_PORT =
  new InjectionToken<ITraceabilityCommandPort>('ITraceabilityCommandPort');
